//register
export const BROADCASTER_REGISTER_REQUEST = "BROADCASTER_REGISTER_REQUEST";
export const BROADCASTER_REGISTER_RECEIVE = "BROADCASTER_REGISTER_RECEIVE";
export const BROADCASTER_REGISTER_FAILURE = "BROADCASTER_REGISTER_FAILURE";
export const BROADCASTER_RESET_REGISTER= "BROADCASTER_RESET_REGISTER";